import script from "./WCWebAdsCarouselModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCWebAdsCarouselModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCWebAdsCarouselModern.vue?vue&type=style&index=0&id=5aa311d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aa311d8"]])

export default __exports__